// extracted by mini-css-extract-plugin
export var activeFilterButton = "_np-c";
export var backButton = "_np-4";
export var backIcon = "_np-5";
export var chevronShortcut = "_np-6";
export var container = "_np-1";
export var editor = "_np-8";
export var editorWrapper = "_np-7";
export var prefix = "_np-2";
export var searchIcon = "_np-3";
export var suffix = "_np-9";
export var suffixContent = "_np-a";
export var suffixText = "_np-b";
export var wrapper = "_np-0";